export type GuideSeo = {
  primaryIntent: string;
  answer?: string;
  dateModified?: string;
};

const priorityGuideSeo: Record<string, GuideSeo> = {
  "/how-to-see-who-someone-followed-on-instagram/": {
    primaryIntent: "see who someone recently followed on Instagram",
    answer:
      "To see who someone recently followed on Instagram, compare public following-list observations over time. Instagram does not provide a complete public history of another person's follows.",
    dateModified: "2026-09-14",
  },
  "/instagram-follow-tracker/": {
    primaryIntent: "Instagram follow tracker",
    answer:
      "An Instagram follow tracker compares snapshots of a public profile's following list and reports detected additions or removals. It should never require your Instagram password.",
    dateModified: "2026-09-14",
  },
  "/instagram-follow-notifications/": {
    primaryIntent: "notifications for new Instagram follows",
    answer:
      "Instagram does not offer a general alert for every follow made by another profile. A tracker can notify you when a change is detected in public activity.",
    dateModified: "2026-09-14",
  },
  "/pt/como-ver-quem-alguem-seguiu-no-instagram/": {
    primaryIntent: "ver quem alguém seguiu recentemente no Instagram",
    answer:
      "Para ver quem alguém seguiu recentemente no Instagram, compare observações da lista pública de seguidos ao longo do tempo. O Instagram não oferece um histórico público completo dos follows de outra pessoa.",
    dateModified: "2026-09-14",
  },
  "/pt/rastreador-de-seguidores-instagram/": {
    primaryIntent: "rastreador de seguidores do Instagram",
    answer:
      "Um rastreador de seguidores do Instagram compara registros da lista pública de seguidos e mostra adições ou remoções detectadas. Ele não deve exigir sua senha do Instagram.",
    dateModified: "2026-09-14",
  },
  "/pt/notificacoes-de-novos-seguidos-instagram/": {
    primaryIntent: "notificações de novos follows no Instagram",
    answer:
      "O Instagram não oferece um alerta geral para cada follow feito por outro perfil. Um rastreador pode avisar quando uma mudança é detectada na atividade pública.",
    dateModified: "2026-09-14",
  },
  "/es/como-ver-a-quien-alguien-siguio-en-instagram/": {
    primaryIntent: "ver a quién alguien siguió recientemente en Instagram",
    answer:
      "Para ver a quién alguien siguió recientemente en Instagram, compara observaciones de su lista pública de seguidos a lo largo del tiempo. Instagram no ofrece un historial público completo de los follows de otra persona.",
    dateModified: "2026-09-14",
  },
  "/es/rastreador-de-seguidores-instagram/": {
    primaryIntent: "rastreador de seguidores de Instagram",
    answer:
      "Un rastreador de seguidores de Instagram compara registros de la lista pública de seguidos y muestra adiciones o eliminaciones detectadas. Nunca debería pedir tu contraseña de Instagram.",
    dateModified: "2026-09-14",
  },
  "/es/notificaciones-nuevos-seguidos-instagram/": {
    primaryIntent: "notificaciones de nuevos follows en Instagram",
    answer:
      "Instagram no ofrece una alerta general para cada follow realizado por otro perfil. Un rastreador puede avisarte cuando detecta un cambio en la actividad pública.",
    dateModified: "2026-09-14",
  },
};

export function getGuideSeo(path: string): GuideSeo {
  return (
    priorityGuideSeo[path] ?? {
      primaryIntent: "Instagram public profile activity",
    }
  );
}
